export default __webpack_public_path__ + "static/media/darkbg2.8a9b2dac.jpg";